import { analytics } from "MVVM/Analytics";

// Every match page event carries the match it happened on, read from the URL
// so components don't have to be handed it.
export const trackMatch = (
  event: string,
  props: Record<string, unknown> = {},
) =>
  analytics.track(`Match Page - ${event}`, {
    matchId: window.location.pathname.split("/").filter(Boolean).pop(),
    ...props,
  });
